import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { ProgressBar } from 'react-bootstrap';

const IndicatorContext = createContext({
  active: false,
  setActive: (val: boolean) => {},
});

export function IndicatorProvider({ children }: React.PropsWithChildren<unknown>): JSX.Element {
  const [active, setActive] = useState(false);
  const value = useMemo(() => ({ active, setActive }), [active, setActive]);

  return <IndicatorContext.Provider value={value}>{children}</IndicatorContext.Provider>;
}

export function Indicator(): JSX.Element {
  const { active } = useContext(IndicatorContext);
  const [percent, setPercent] = useState(0);

  useEffect(() => {
    if (active) {
      const timing = setInterval(() => {
        setPercent((currPercent) => {
          return currPercent < 100 ? currPercent + 5 : 100;
        });
      }, 10);

      return () => {
        clearInterval(timing);
        setPercent(0);
      };
    }
  }, [active]);

  return active ? (
    <ProgressBar
      style={{
        height: 3,
        borderRadius: 0,
        position: 'absolute',
        top: '0',
        left: 0,
        right: 0,
        zIndex: 99999,
      }}
      striped
      now={percent}
    />
  ) : <></>;
}

export function IndicatorFallback(): JSX.Element {
  const { setActive } = useContext(IndicatorContext);
  useEffect(() => {
    setActive(true);
    return () => setActive(false);
  });
  return <></>;
}
